module.exports = __webpack_public_path__ + "SuryaShanka-6137c873.webp";